import BaseInput from 'component/input/BaseInput'
import ContentType from "component/content/content-type";
import ContentDuration from "component/content/content-type/content-duration";

export default function ContentSubmapelItem({ item, sections, selectedContent = [], setContentSelected = () => { } }) {
  return (
    <div className="mb-0 border-top border-right border-left border-bottom">
      <SectionItem item={item} selectedContent={selectedContent} setContentSelected={setContentSelected} />

      <div className="collapse show">
        <ul className="list-unstyled mb-0">
          {item?.contents?.length !== 0 ? (
            item?.contents?.map((content, index) => (
              <ContentItem
                key={content?.id}
                item={content}
                index={index}
                classId={item?.class_id}
                sectionId={item?.id}
                sections={sections}
                selectedContent={selectedContent}
                setContentSelected={setContentSelected}
              />
            ))
          ) : (
            <p className="text-muted p-3 mb-0">Belum ada materi.</p>
          )}
        </ul>
      </div>
    </div>
  )
}

function SectionItem({ item, selectedContent, setContentSelected }) {
  /* ========================================== Local States ========================================= */
  const isSectionSelected = selectedContent.some(c => c.id === item?.class_id && c.data.some(s => s.section_id === item?.id))
  return (
    <div
      id={item?.id}
      style={{
        backgroundColor: '#f8f9fa',
      }}
    >
      <h5 className="row m-0 border-bottom">
        <div
          className="col row text-dark py-2 m-0"
        >
          <div
            className="col px-0 d-flex justify-content-between align-items-center"
            style={{ height: '50px' }}
          >
            <span className="f-16">
              {item?.urutan}
              {'. '}
              {item?.title}{' '}
              {item?.active ? (
                <span
                  className="badge badge-success ml-2"
                  style={{ fontSize: '12px' }}
                >
                  Aktif
                </span>
              ) : (
                <span
                  className="badge badge-secondary ml-2"
                  style={{ fontSize: '12px' }}
                >
                  Tidak Aktif
                </span>
              )}
            </span>
            <span
              style={{
                display: 'inline-block',
                fontWeight: '400',
              }}
            >
              {item?.contents?.length}
              {' materi'}
            </span>
            <span
            >
              <BaseInput
                id={`checkbox-section-${item?.id}`}
                type="checkbox"
                isWithLabel={false}
                props={{
                  onChange: e => {
                    setContentSelected({
                      type: 'section',
                      classId: item?.class_id,
                      sectionId: item?.id,
                      checked: e.target.checked,
                      sectionContents: item?.contents
                    })
                  },
                  checked: isSectionSelected
                }}
              />
            </span>
          </div>
        </div>
      </h5>
    </div>
  )
}

function ContentItem({ item, classId, sectionId, selectedContent, setContentSelected }) {
  /* ========================================== Local States ========================================= */
  const isContentSelected = selectedContent.some(c => c.id === classId && c.data.some(s => s.section_id === sectionId && s.contents_id.includes(item?.id)))
  return (
    <li>
      <div
        className="p-3 f-16 text-left text-dark"
        style={{
          width: '100%',
          height: '75px',
          backgroundColor: 'transparent'
        }}
      >
        <div className="row">
          <div className="col d-flex justify-content-between align-items-center">
            <span
              style={{
                display: 'inline-block',
              }}
            >
              <span className={`text-dark d-block f-16`}>
                {item.urutan}
                {'. '}
                {item.title}{' '}
                {item.active ? (
                  <span
                    className="badge badge-success ml-2"
                    style={{ fontSize: '12px' }}
                  >
                    Aktif
                  </span>
                ) : (
                  <span
                    className="badge badge-secondary ml-2"
                    style={{ fontSize: '12px' }}
                  >
                    Tidak Aktif
                  </span>
                )}
                {item?.is_spesifik === true
                  ?
                  <span
                    className="badge badge-primary ml-2"
                    style={{ fontSize: '12px' }}
                  >
                    Spesifik Siswa {item?.content_specific_users?.length ? `(${item?.content_specific_users.length})` : ''}
                  </span>
                  : null}
                {item?.is_score
                  ?
                  <span
                    className="badge badge-warning ml-2"
                    style={{ fontSize: '12px' }}
                  >
                    Penilaian
                  </span>
                  : null}
              </span>
              <span className="d-block">
                <ContentType id={item.content_type_id} />
                <ContentDuration durasi={item.durasi} />
              </span>
            </span>
            <span>
              <BaseInput
                id={`checkbox-content-${item?.id}`}
                type="checkbox"
                isWithLabel={false}
                props={{
                  onChange: e => {
                    setContentSelected({
                      type: 'content',
                      classId: classId,
                      sectionId: sectionId,
                      contentId: item?.id,
                      checked: e.target.checked
                    })
                  },
                  checked: isContentSelected
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </li>
  )
}